// actions/vcfDataReducer.ts
import axios from 'axios';
import { Dispatch } from 'redux';
// @ts-ignore
import { parseVcf } from "../libs/vcard/vcardParser/VCFParser.ts";
import { VCard } from "../types/ParsedVCardTypes"
import { SERVER_URL } from '../config';
import {processHonorifics} from "../libs/vcard/vcardDataPostProcessing/Honorifics";
import {postProcessOrgFields} from "../libs/vcard/vcardDataPostProcessing/OrganizationProjection";
// @ts-ignore
import {filterVCardFieldsForWork} from "../libs/vcard/vcardDataPostProcessing/OnlyWorkValues.ts";
// @ts-ignore
import {removeCharsetFromVCards} from "../libs/vcard/vcardDataPostProcessing/Cleaner.ts";

// Export Action interfaces
export interface FetchVcfDataBeginAction {
    type: 'FETCH_VCF_DATA_BEGIN';
}

export interface FetchVcfDataSuccessAction {
    type: 'FETCH_VCF_DATA_SUCCESS';
    payload: {
        data: VCard[]; // Use VCard[] type here
    };
}

export interface FetchVcfDataFailureAction {
    type: 'FETCH_VCF_DATA_FAILURE';
    payload: {
        error: string;
    };
}

// Combine the action types using a TypeScript union
export type VcfActions = FetchVcfDataBeginAction | FetchVcfDataSuccessAction | FetchVcfDataFailureAction;

export function fetchVcfData(filename: string) {
    return function(dispatch: Dispatch<VcfActions>) {
        dispatch(fetchVcfDataBegin());

        return axios
            .get(`${SERVER_URL}/${filename}`, { responseType: 'text' })
            .then((response) => {
                const cards = parseVcf(response.data);
                const noCharset: VCard[] = removeCharsetFromVCards(cards)
                const filteredByWork = filterVCardFieldsForWork(noCharset)
                const processedCards = processHonorifics(filteredByWork);
                let vcfData = postProcessOrgFields(processedCards);

                // After processing, generate the vCard string
                //vcfData.vCardString = createVCard(vcfData);

                // Dispatch another action to consume data
                dispatch(fetchVcfDataSuccess(vcfData));
            })
            .catch((error) => {
                const errorMessage = error instanceof Error ? error.message : String(error);
                console.error('VCF fetch failed:', errorMessage, error);
                dispatch(fetchVcfDataFailure(errorMessage));
            });
    };
}

// Other action creators...
export const fetchVcfDataBegin = (): FetchVcfDataBeginAction => ({
    type: 'FETCH_VCF_DATA_BEGIN'
});

export const fetchVcfDataSuccess = (data: VCard[]): FetchVcfDataSuccessAction => ({
    type: 'FETCH_VCF_DATA_SUCCESS',
    payload: { data }
});

export const fetchVcfDataFailure = (error: string): FetchVcfDataFailureAction => ({
    type: 'FETCH_VCF_DATA_FAILURE',
    payload: { error }
});